// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"362":"98826366","419":"8509de77","433":"4fc100a1","582":"691a97e8","608":"98826366","648":"ef441a5b","662":"4d8503c5","775":"d99792c2","823":"98826366"}[chunkId] + ".chunk.css";
};